import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const MoveInmateIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M6.05936 0.341061C6.52087 -0.113686 7.26713 -0.113686 7.72372 0.341061C8.18032 0.795809 8.18523 1.53114 7.72372 1.98105L5.02343 4.64181L21.8192 4.64664C22.4722 4.64664 22.9975 5.16428 22.9975 5.8077C22.9975 6.45112 22.4722 6.96876 21.8192 6.96876H5.02343L7.72372 9.62951C8.18523 10.0843 8.18523 10.8196 7.72372 11.2695C7.26222 11.7194 6.51596 11.7242 6.05936 11.2695L1.34613 6.63012C0.884624 6.17537 0.884624 5.44003 1.34613 4.99012L6.05936 0.3459V0.341061ZM22.6539 17.3699C23.1154 17.8246 23.1154 18.56 22.6539 19.0099L17.9406 23.6589C17.4791 24.1137 16.7329 24.1137 16.2763 23.6589C15.8197 23.2042 15.8148 22.4689 16.2763 22.0189L18.9766 19.3582L2.18076 19.3534C1.52778 19.3534 1.00245 18.8357 1.00245 18.1923C1.00245 17.5489 1.52778 17.0312 2.18076 17.0312H18.9766L16.2763 14.3705C15.8148 13.9157 15.8148 13.1804 16.2763 12.7305C16.7378 12.2806 17.484 12.2758 17.9406 12.7305L22.6539 17.3747V17.3699Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default MoveInmateIcon
